import { autoinject } from "aurelia-framework";
import { EventAggregator, Subscription } from "aurelia-event-aggregator";
import { GreenhouseDataEvents } from "../events/data-events";
import { Structure } from "../models/structure";
import * as Enumerable from 'linq-es2015';


export class NotificationStatus {
    id: number;
    name: string;
}

@autoinject
export class NotificationStatusSelector {

    structure: Structure;
    selectedNotificationStatus: NotificationStatus;
    notificationStatuses: NotificationStatus[];
    private readonly eventAggregator: EventAggregator;

    constructor(eventAggregator: EventAggregator) {
        this.eventAggregator = eventAggregator;


        this.notificationStatuses = [
            { id: 0, name: "Disabled" }, { id: 1, name: "Enabled" }, { id: 2, name: "Paused" }
        ];
    }

    bind(bindingContext: any, overrideContext: any) {
      this.structure = bindingContext.greenhouse;
      this.selectedNotificationStatus = this.getNotificationStatus(this.structure.notificationStatus);
    }

    getNotificationStatus(id: number): NotificationStatus {
        const enumerable = Enumerable.AsEnumerable(this.notificationStatuses);
        return enumerable.FirstOrDefault(type => type.id === id);
    }
  
    notificationStatusChanged() {
        this.structure.notificationStatus = this.selectedNotificationStatus.id;
        this.eventAggregator.publish(GreenhouseDataEvents.greenhouseNotificationStatusUpdated, this.structure);
    }
}